module.exports = __webpack_public_path__ + "img/1-6.58c9d603.png";